import SeventhSnapshotRevealPage from 'containers/7th-snapshot-reveal'

export default SeventhSnapshotRevealPage

export const getStaticProps = async () => ({
  props: {
    pageTitle: 'DEADROP Snapshot VII Reveal',
  },
})
